import { logError as sentryLogError } from 'sletat-sentry';
import { flightsParser, FlightsParsingResources } from 'sletat-api-services/lib/module/flights/utils/parser';

import { parseDateString } from 'sletat-common-utils/lib/date/lib/parseDateString';

import { DirectionEndPointData, FlightItem, FlightsParsedData } from '../models/flights';
import { hotelPageLogger } from '../../utils/logger';
import { defaultFlightPackage } from '../consts/flights';


export function parseFlights(parsingData: FlightsParsingResources, tourId: string): FlightsParsedData {
    try {
        return flightsParser(parsingData);
    } catch (err) {
        hotelPageLogger.warn(`flightsParser failed for tour ${tourId}`);
        // @ts-expect-error
        sentryLogError(err);

        return defaultFlightPackage;
    }
}


export function mapEndPoint(flight: FlightItem | undefined, isLast: boolean = false): DirectionEndPointData {
    return {
        date: (flight
            ? isLast
                ? flight.endDate && parseDateString(flight.endDate, 'DD.MM.YYYY') || null
                : flight.startDate && parseDateString(flight.startDate, 'DD.MM.YYYY') || null
            : null
        ),
        time: (flight
            ? isLast
                ? flight.endTime || null
                : flight.startTime || null
            : null
        ),
        city: (flight
            ? isLast
                ? flight.airportToCityName || null
                : flight.airportFromCityName || null
            : null
        ),
        flightId: (flight && flight.flight) || null,
        airportCode: (flight
            ? isLast
                ? flight.airportToCode || null
                : flight.airportFromCode || null
            : null),
        airportName: (flight
            ? isLast
                ? flight.airportToName || null
                : flight.airportFromName || null
            : null
        )
    };
}
